import { __decorate } from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { action, computed, get, set } from 'mobx';
import classNames from 'classnames';
import { pxToRem } from '../../../lib/_util/UnitConvertor';
import measureScrollbar from '../../../lib/_util/measureScrollbar';
import { columnWidth } from './Column';
import TableContext from './TableContext';
import { ColumnLock, DragColumnAlign } from './enum';
import TableFooterCell from './TableFooterCell';
import { getColumnKey, getColumnLock, getHeight, isStickySupport } from './utils';
import autobind from '../_util/autobind';
import ResizeObservedRow from './ResizeObservedRow';
import { CUSTOMIZED_KEY } from './TableStore';
let TableFooter = class TableFooter extends Component {
    saveRef(node) {
        this.node = node;
    }
    handleResize(index, height) {
        this.setRowHeight(index, height);
    }
    setRowHeight(index, height) {
        const { tableStore } = this.context;
        set(tableStore.lockColumnsFootRowsHeight, index, height);
    }
    getTds() {
        const { lock, dataSet } = this.props;
        const { tableStore } = this.context;
        const { prefixCls, customizable, rowDraggable, dragColumnAlign } = tableStore;
        const hasPlaceholder = tableStore.overflowY && lock !== ColumnLock.left;
        let leftWidth = 0;
        let rightWidth = isStickySupport() && tableStore.overflowX ? tableStore.rightLeafColumnsWidth + (hasPlaceholder ? measureScrollbar() : 0) : 0;
        const tds = this.leafColumns.map((column, index, cols) => {
            const key = getColumnKey(column);
            if (key !== CUSTOMIZED_KEY) {
                const colSpan = customizable && lock !== ColumnLock.left && (!rowDraggable || dragColumnAlign !== DragColumnAlign.right) && index === cols.length - 2 ? 2 : 1;
                const props = {};
                if (colSpan > 1) {
                    props.colSpan = colSpan;
                }
                if (isStickySupport() && tableStore.overflowX) {
                    const columnLock = getColumnLock(column.lock);
                    if (columnLock === ColumnLock.left) {
                        props.style = {
                            left: pxToRem(leftWidth),
                        };
                        const next = cols[index + 1];
                        if (!next || getColumnLock(next.lock) !== ColumnLock.left) {
                            props.className = `${prefixCls}-cell-fix-left-last`;
                        }
                        leftWidth += columnWidth(column);
                    }
                    else if (columnLock === ColumnLock.right) {
                        rightWidth -= columnWidth(column);
                        const prev = cols[index - 1];
                        if (!prev || prev.lock !== ColumnLock.right) {
                            props.className = `${prefixCls}-cell-fix-right-first`;
                        }
                        if (colSpan > 1) {
                            for (let i = 1; i < colSpan; i++) {
                                const next = cols[index + i];
                                if (next) {
                                    rightWidth -= columnWidth(next);
                                }
                            }
                        }
                        props.style = {
                            right: pxToRem(rightWidth),
                        };
                    }
                }
                return (React.createElement(TableFooterCell, Object.assign({ key: key, dataSet: dataSet, column: column }, props)));
            }
            return undefined;
        });
        if (hasPlaceholder) {
            const placeHolderProps = {
                key: 'fixed-column',
            };
            const classList = [`${prefixCls}-cell`];
            if (isStickySupport() && tableStore.overflowX) {
                placeHolderProps.style = { right: 0 };
                classList.push(`${prefixCls}-cell-fix-right`);
            }
            placeHolderProps.className = classList.join(' ');
            tds.push(React.createElement("th", Object.assign({}, placeHolderProps), "\u00A0"));
        }
        return tds;
    }
    getHeight() {
        const { node } = this;
        if (node) {
            return getHeight(node);
        }
        return 0;
    }
    render() {
        const { lock } = this.props;
        const { tableStore, } = this.context;
        const { prefixCls, autoFootHeight, rowHeight, overflowX } = tableStore;
        const tds = this.getTds();
        const tr = (React.createElement("tr", { style: {
                height: !isStickySupport() && lock && (rowHeight === 'auto' || autoFootHeight) ? pxToRem(get(tableStore.lockColumnsFootRowsHeight, 0)) : undefined,
            } }, tds));
        return (React.createElement("tfoot", { ref: this.saveRef, className: classNames(`${prefixCls}-tfoot`, { [`${prefixCls}-tfoot-bordered`]: overflowX }) }, !isStickySupport() && !lock && (rowHeight === 'auto' || autoFootHeight) ? (React.createElement(ResizeObservedRow, { onResize: this.handleResize, rowIndex: 0 }, tr)) : tr));
    }
    get leafColumns() {
        const { tableStore } = this.context;
        const { lock } = this.props;
        if (lock === ColumnLock.right) {
            return tableStore.rightLeafColumns.filter(({ hidden }) => !hidden);
        }
        if (lock) {
            return tableStore.leftLeafColumns.filter(({ hidden }) => !hidden);
        }
        return tableStore.leafColumns.filter(({ hidden }) => !hidden);
    }
};
TableFooter.displayName = 'TableFooter';
TableFooter.propTypes = {
    lock: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.oneOf([ColumnLock.right, ColumnLock.left]),
    ]),
};
TableFooter.contextType = TableContext;
__decorate([
    autobind
], TableFooter.prototype, "saveRef", null);
__decorate([
    autobind
], TableFooter.prototype, "handleResize", null);
__decorate([
    action
], TableFooter.prototype, "setRowHeight", null);
__decorate([
    computed
], TableFooter.prototype, "leafColumns", null);
TableFooter = __decorate([
    observer
], TableFooter);
export default TableFooter;
